export const capitalize = (text) => text.charAt(0).toUpperCase() + text.slice(1);
//# sourceMappingURL=string.js.map